// extracted by mini-css-extract-plugin
export default {"ButtonSecondary":"ButtonSecondary_ButtonSecondary__7cUG1"};